import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import { addEvent, removeEvent } from "../lib/eventHandler";

export interface ClickTriggerParam {
    selector: string;
    clicksRequired: number; // Number of clicks required to trigger the event
}

export class ClickTrigger implements Trigger {
    params: ClickTriggerParam;
    constructor(params: ClickTriggerParam) {
        this.params = params;
    }

    applyToAll(elements: any, action: any, type: any, fn: any) {
        for (var i = 0; i < elements.length; i++) {
            action(elements[i], type, fn);
        }
    }

    init = (action: Action) => {
        let clickCounter = 0;
        const elements = document.querySelectorAll(this.params.selector);
        if (!elements) return;

        var fn = () => {
            clickCounter = clickCounter + 1;
            if (!this.params.clicksRequired || clickCounter === this.params.clicksRequired) {
                action.execute();
            }
        };
        this.applyToAll(elements, addEvent, "click", fn);
    };
}
